module.exports = __webpack_public_path__ + "media/images/illust/illust-family-ac3ea13c8b34ec8b4d803880958367d3.svg";